import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React, { useState } from 'react';

import colors from "../../utils/colors";
import Button from "../Button";
import RightSidebar from "../RightSidebar";
import FilterArrowButton from "../FilterArrowButton";
import { ProductLineSectionType, PRODUCT_LINES_CONTENT_MAP } from "../../utils/ProductLinesHelper";
import ChevronDown from "../../icons/ChevronDown";
import ChevronUp from "../../icons/ChevronUp";
import ShieldHeart from "../../icons/ShieldHeart";
import { createStyles } from "./styles";
import ProductLineSection from "./ProductLineSection";
import IconCheckmark from "../../icons/IconCheckmark";

var ProposalSidebar = function ProposalSidebar(_ref)

















{var _context, _context2;var isOpen = _ref.isOpen,_ref$width = _ref.width,width = _ref$width === void 0 ? '' : _ref$width,_ref$sidebarStyles = _ref.sidebarStyles,sidebarStyles = _ref$sidebarStyles === void 0 ? '' : _ref$sidebarStyles,closeButton = _ref.closeButton,_ref$additionalButton = _ref.additionalButton,additionalButton = _ref$additionalButton === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$additionalButton,onActionClick = _ref.onActionClick,productLineIds = _ref.productLineIds,cartItems = _ref.cartItems,_ref$type = _ref.type,type = _ref$type === void 0 ? 'browsing' : _ref$type,_ref$sidebarTitle = _ref.sidebarTitle,sidebarTitle = _ref$sidebarTitle === void 0 ? '' : _ref$sidebarTitle,submitButton = _ref.submitButton,onProductLineChange = _ref.onProductLineChange,onSaveProposal = _ref.onSaveProposal,onRemoveFromProposal = _ref.onRemoveFromProposal,onCompareAllPortfoliosInPl = _ref.onCompareAllPortfoliosInPl;
  var classes = createStyles(type);
  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),showAncillaryProductLines = _useState2[0],setShowAncillaryProductLines = _useState2[1];

  var GeneralProposalSections = _mapInstanceProperty(_context = _filterInstanceProperty(productLineIds).call(productLineIds,

  function (productLine) {var _PRODUCT_LINES_CONTEN;return (
      ((_PRODUCT_LINES_CONTEN = PRODUCT_LINES_CONTENT_MAP[productLine]) === null || _PRODUCT_LINES_CONTEN === void 0 ? void 0 : _PRODUCT_LINES_CONTEN.section) === ProductLineSectionType.GENERAL);})).call(_context,

  function (pLId) {
    // Cart items for current product line
    var filteredCartItems = _filterInstanceProperty(cartItems).call(cartItems, function (item) {return item.productLineId === pLId;});
    return /*#__PURE__*/(
      React.createElement(ProductLineSection, {
        key: pLId,
        productLineSection: ProductLineSectionType.GENERAL,
        productLineId: pLId,
        cartItems: filteredCartItems,
        onProductLineChange: onProductLineChange,
        onRemoveFromProposal: onRemoveFromProposal,
        onCompareAllPortfoliosInPl: onCompareAllPortfoliosInPl }));


  });

  var ancillaryProductLines = _filterInstanceProperty(productLineIds).call(productLineIds,
  function (productLine) {var _PRODUCT_LINES_CONTEN2;return (
      ((_PRODUCT_LINES_CONTEN2 = PRODUCT_LINES_CONTENT_MAP[productLine]) === null || _PRODUCT_LINES_CONTEN2 === void 0 ? void 0 : _PRODUCT_LINES_CONTEN2.section) === ProductLineSectionType.ANCILLARY);});


  var ancillaryProductLinesNumber = ancillaryProductLines.reduce(function (acc, line) {
    var hasItemsInLine = cartItems.some(function (item) {return item.productLineId === line;});
    return acc + (hasItemsInLine ? 1 : 0);
  }, 0);

  var AncillaryProposalSections = _mapInstanceProperty(ancillaryProductLines).call(ancillaryProductLines, function (pLId) {
    // Cart items for current product line
    var filteredCartItems = _filterInstanceProperty(cartItems).call(cartItems, function (item) {return item.productLineId === pLId;});
    return /*#__PURE__*/(
      React.createElement(ProductLineSection, {
        key: pLId,
        productLineSection: ProductLineSectionType.ANCILLARY,
        productLineId: pLId,
        cartItems: filteredCartItems,
        onProductLineChange: onProductLineChange,
        onRemoveFromProposal: onRemoveFromProposal,
        onCompareAllPortfoliosInPl: onCompareAllPortfoliosInPl }));


  });

  var ancillarySectionsNumber = AncillaryProposalSections.length;

  var AncillaryProductLinesBlock = /*#__PURE__*/
  React.createElement("div", null, /*#__PURE__*/
  React.createElement("div", { className: classes.collapsedSectionsWrapper }, /*#__PURE__*/
  React.createElement(Button, {
    type: "text",
    size: "medium",
    color: "custom",
    customColor: colors.neutral[900],
    leftIconProp: /*#__PURE__*/React.createElement(ShieldHeart, null),
    rightIconProp: showAncillaryProductLines ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null),
    onClick: function onClick() {
      setShowAncillaryProductLines(!showAncillaryProductLines);
    },
    className: classes.collapsedProductLineButton }, "Ancillary"), /*#__PURE__*/



  React.createElement("span", {
    className: classes.infoMessage }, _concatInstanceProperty(_context2 = "".concat(
  ancillaryProductLinesNumber, "/")).call(_context2, ancillarySectionsNumber, " selected"))),

  showAncillaryProductLines && AncillaryProposalSections);



  return /*#__PURE__*/(
    React.createElement(RightSidebar, { isOpen: isOpen, sidebarStyles: sidebarStyles, width: width }, /*#__PURE__*/
    React.createElement(React.Fragment, null,
    closeButton && /*#__PURE__*/
    React.createElement(FilterArrowButton, { direction: "right", button: closeButton, onActionClick: onActionClick }), /*#__PURE__*/

    React.createElement("h2", { className: classes.sidebarTitle }, sidebarTitle || 'Proposal Details'),
    GeneralProposalSections,
    ancillarySectionsNumber > 0 && AncillaryProductLinesBlock, /*#__PURE__*/
    React.createElement("div", { className: classes.footerButtons },
    additionalButton,
    submitButton || /*#__PURE__*/
    React.createElement(React.Fragment, null,
    (type === 'browsing' || type === 'renewal') && onSaveProposal && /*#__PURE__*/
    React.createElement(Button, {
      size: "large",
      color: "custom",
      disabled: cartItems.length === 0,
      customColor: colors.green[600],
      onClick: onSaveProposal }, "Save Proposal"))),







    type === 'template' && /*#__PURE__*/
    React.createElement("div", { className: classes.savingStatusWrapper }, /*#__PURE__*/
    React.createElement(IconCheckmark, { width: "2.3rem" }), /*#__PURE__*/
    React.createElement("p", { className: classes.savingStatus }, "All changes autosaved")))));





};

export default ProposalSidebar;
//# sourceMappingURL=index.js.map